//General functionality that is used around the site.

// We depending on the Context / Scope of PCI complient we may access the same attributes either in the parent window or sandboxed iframe.
import { paymentSelectorAttibutes } from './payment-utilities';

// Check to see if running in development.
window.isRunningDevelopment = () => {
  return (location.hostname == "localhost" || location.hostname == "express.staging.axisfirst.net");
}

// Check if this is a logged out simulation.
window.isAuthentication = () => {
  const pathname = location.pathname;
  // May need to create a more complex mechanism later ....
  return (!pathname.includes("-alt."));
}


window.isRunningStandalone = () => {
  return (
    window.matchMedia('(display-mode: standalone)').matches || // Most modern browsers
    window.navigator.standalone === true // iOS Safari
  );
}

// Check if the PWA is installed using the getInstalledRelatedApps API.
window.getInstalledRelatedApps = () => {
  if ('getInstalledRelatedApps' in navigator) {
    return navigator.getInstalledRelatedApps();
  }
  // Return empty array wrapped in a promise for browsers that don't support the API.
  return Promise.resolve([]);
}

// Clear all web storage associated with the current origin, Covers localStorage, sessionStorage, cookies ( non-HttpOnly only ), Cache API and IndexedDB.
window.clearWebStorage = () => {
  return new Promise(function(resolve) {
    let results = {
      localStorage: false,
      sessionStorage: false,
      cookies: false,
      caches: false,
      indexedDB: false
    };

    // 1. localStorage.
    try {
      localStorage.clear();
      results.localStorage = true;
    } catch (e) {}

    // 2. sessionStorage.
    try {
      sessionStorage.clear();
      results.sessionStorage = true;
    } catch (e) {}

    // 3. Cookies ( non-HttpOnly only, HttpOnly cookies are invisible to JavaScript and require server-side clearing ).
    try {
      var cookies = document.cookie.split(';');
      for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i];
        var name = cookie.split('=')[0].trim();
        if (name) {
          document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/';
        }
      }
      results.cookies = true;
    } catch (e) {}

    // 4. Cache API.
    var cachesPromise;
    if ('caches' in window) {
      cachesPromise = caches.keys().then(function(names) {
        return Promise.all(names.map(function(name) {
          return caches.delete(name);
        }));
      }).then(function() {
        results.caches = true;
      }).catch(function() {});
    } else {
      cachesPromise = Promise.resolve();
    }

    // 5. IndexedDB ( indexedDB.databases() is Chromium only, gracefully skipped where unsupported ).
    var indexedDBPromise;
    if ('indexedDB' in window && typeof indexedDB.databases === 'function') {
      indexedDBPromise = indexedDB.databases().then(function(databases) {
        databases.forEach(function(db) {
          indexedDB.deleteDatabase(db.name);
        });
        results.indexedDB = true;
      }).catch(function() {});
    } else {
      indexedDBPromise = Promise.resolve();
    }

    // Wait for async operations then resolve.
    Promise.all([cachesPromise, indexedDBPromise]).then(function() {
      resolve(results);
    });
  });
}

//---- Breakpoint calculator ----
//Used to map a numerical value to each breakpoint instead of a string.
window.currentBreakpoint = () => {
    var currentBreakpoint = Foundation.MediaQuery.current;
    // Find numeric value.
    return getBreakpoint(currentBreakpoint);
}
// Breakpoint numberic mapping.
window.getBreakpoint = (breakpoint) => {
  switch(breakpoint) {
    case "small": 
      return 1;
    case "medium":
      return 2;
    case "large": 
      return 3;
    case "xlarge":
      return 4;
    case "xxlarge":
      return 5;
    default:
      AXISDebug.output(2,"Failed to get breakpoint's numeric value.", breakpoint);
      return false;
  }
}

//----- Page Overlay -----
// Used to close menu's / dropdowns
// TODO: This is the original blur function which is a bit naff instead you should use blurContent().
window.pageOverlay = (disable, blurBackground = false) => {
    //Checks if overlay exists.
    if (!$('#pageOverlay').length) {
      if (AXISDebug.level() >= 4) {
        AXISDebug.output(1,"Page overlay: Applying overlay");
      }
      //If it doesn't, then apply it.
      $('body').append('<div id="pageOverlay"></div>')
    } else {
      if (AXISDebug.level() >= 4) {
        AXISDebug.output(1,"Page overlay: Removing overlay");
      }
        //Disable overlay.
        $('#pageOverlay').remove();
    }
    if (blurBackground) {
      if (AXISDebug.level() >= 4) {
        AXISDebug.output(1, "Page overlay: Blurring page content.");
      }
      $('#mainContentContainer, #breadcrumb-vat-switcher-container, #usp-bar').toggleClass('blur');
    } else {
      if ($('#mainContentContainer').hasClass('blur')) {
        $('#mainContentContainer, #breadcrumb-vat-switcher-container, #usp-bar').toggleClass('blur');
      }
    }
    //Force the overlay to disable.
    if (disable) {
      if (AXISDebug.level() >= 4) {
        AXISDebug.output(1,"Page Overlay: Removing overlay.");
      }
      $('#pageOverlay').remove();
      // Remove the scroll lock.
      bodyScrollLock(true);
    }
}

window.getWindowHeight = () => {
  let height = $(window).height();
  return parseInt(height);
}

//--- Body scroll lock ---
//Used for locking the body's scroll ability when the a model/lightbox is open.
window.bodyScrollLock = (forceClose = false) => {
    if (!$("body").hasClass('scrollLock') && forceClose == false) {
      $('body').addClass('scrollLock');
      if (AXISDebug.level() >= 4) {
        AXISDebug.output(1,"Scroll lock applied")
      }
    } else if ($('body').hasClass('scrollLock')) {
      $("body").removeClass('scrollLock');
      if (AXISDebug.level() >= 4) {
        AXISDebug.output(1,"Scroll lock removed")
      }
    }
  }

//----- URL TOOLS -----
//--- URL paramenter 'getter' ---
window.getUrlParameter = (sParam, decode) => {
  //Split query string content.
  var sPageURL = window.location.search.substring(1),
    sURLVariables = sPageURL.split('&'),
    sParameterName,
    i;
    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');
      if (sParameterName[0] === sParam) {
        //If Decode flag is set else leave the query string contents encoded.
        if (decode) {
          return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        } else {
          return sParameterName[1];
        }
       
    }
  }
};

// --- Get query string parameters from a string ---
// This will return an object where the first key will be the source url + first parameter, if query string values then the first property of the return object will not have a value.
window.getQueryStringParams = (query) => {
  return query
      ? (/^[?#]/.test(query) ? query.slice(1) : query)
          .split('&')
          .reduce((params, param) => {
                  let [key, value] = param.split('=');
                  params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
                  return params;
              }, {}
          )
      : {}
};

// Determine whether there is a query string value in a string 
window.queryStringParamsExists = (query) => {
  // Get query string parmeters, this will bring back an array.
  let queryStringParameters = getQueryStringParams(query);
  // Check the first value in the array if it has a value.
  if (getQueryStringParams(query)[Object.keys(queryStringParameters)[0]] === '') {
    return false;
  } else {
    return true;
  }
}

//----- Random Id generator ----- 
window.generateId = (idLength = 6) => {
  var result           = '';
  var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var charactersLength = characters.length;
  for ( var i = 0; i < idLength; i++ ) {
     result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

// ----- Page reload -----
// Manually reload the page
window.reloadPage = () => {
  location.reload();
}

window.getHeaderSize = () => {
  let headerSize = $('header [' + expressSelectors()['axis-sticky']['initialise'] + '] .header-container').outerHeight();
  // Fallback until wearesync is done.
  if (!headerSize) {
    headerSize = $('#stickyHeader').height();
  }
  if (headerSize) {
    if (AXISDebug.level() >= 3) {
      AXISDebug.output(1,"Header Size: returning the header size: ", headerSize);
    }
    return parseInt(headerSize);
  } else {
    return 0;
  }
}

// Get specifically the stuck size, this is require for when you're scroll to an anchor.
window.getHeaderStuckSize = () => {
  let element = $('header [' + expressSelectors()['axis-sticky']['initialise'] + ']');
  // Is the header currently stuck?
  const isStuck = isHeaderStuck();
  // Size.
  let size = null;
  if (!isStuck) {
    element.addClass('is-stuck');
  }
  size = getHeaderSize();
  if (!isStuck) {
    element.removeClass('is-stuck');
  }
  return size;
}

// Check whether header is stuck.
window.isHeaderStuck = () => {
  // Get header context.
  let header = $('header [' + expressSelectors()['axis-sticky']['initialise'] + ']');
  // Is stuck?
  let isStuck = header.hasClass('is-stuck');
  // Fallback until wearesync is done.
  if (!header) {
    header = $('#stickyHeader');
    isStuck = header.hasClass('is-sticky');
  }
  return isStuck;
}

// Check whether the the sticky header is covering content that " should " be in view.
window.isHeaderOverlapping = (content) => {
  // TODO: Check whether header is actually stuck first!!
  if (!isHeaderStuck()) {
    return false;
  }
  // Get the header size.
  let headerSize = getHeaderSize();
  // Get content position.
  let contentPos = content.offset().top;
  // Get scroll position.
  let scrollPos = $(window).scrollTop();
  // Perform check.
  if ((contentPos - scrollPos) < headerSize) {
    // When scrolling into possition give the header some breathing room.
    let padding = 20;
    if (AXISDebug.level() >= 4) {
      AXISDebug.output(1, "Sticky header is overlapping content that should be in view attempting to scroll content into view.");
    }
    let scrollAmount = (headerSize - (contentPos - scrollPos));
    // Scroll content into view.
    $("html, body").animate({ scrollTop: (scrollPos - padding) - scrollAmount });
    return scrollAmount;
  } else {
    return false;
  }

}

// Find the closest value inside of an array and pass back its index.
window.getClosestIndexValue = (array, goal) => {
  // Check each item in the array.
  var closest = array.reduce((previousValue, currentValue) => {
      // Compare the goal against the values inside of the array.
      return Math.abs(currentValue - goal) < Math.abs(previousValue - goal) ? currentValue : previousValue;
  });
  // Get the index of the closest value.
  closest = array.indexOf(closest);
  // Return the closest value in the array.
  return closest;
}

// Find largest value in array.
window.largestValue = (array) => {
  return Math.max(...array);
}

// Get index of largest value.
window.indexLargestValue = (array) => {
  return array.indexOf(Math.max(...array));
}

// Find Lowest value in array.
window.lowestValue = (array) => {
  return Math.min(...array);
}

// Get in of lowest value.
window.indexLowestValue = (array) => {
  return array.indexOf(Math.min(...array));
}

window.convertPxToVh = (pixels) => {
  // Vertical height calculation.
  let vh = Math.round(( 100 * pixels) / window.innerHeight);
  return vh;
}

// Test value if it is a multiple of.
window.multipleOf = (value, multiple) => {
  // Make sure value's are integers.
  value = parseInt(value);
  multiple = parseFloat(multiple);
  // Do calculation & return boolean.
  return (parseInt(value) % multiple == 0);
}

// Round down to nearest multiple.
window.roundDown = (value, multiple) => {
  // Make sure value's are integers.
  value = parseInt(value);
  multiple = parseFloat(multiple);
  // Do calculation.
  return (Math.floor(value / multiple) * multiple);
}

// Round up to nearest multiple.
window.roundUp = (value, multiple) => {
  // Make sure value's are integers.
  value = parseInt(value);
  multiple = parseFloat(multiple);
  // Do calculation.
  return (Math.ceil(value / multiple) * multiple);
}

// Check if value is between two values.
window.valueBetween = (value, lower, upper) => {
  // Parse values.
  value = parseInt(value);
  upper = parseInt(upper);
  lower = parseInt(lower);
  // Return value of check.
  return (value > lower && value < upper);
}
// Get the total value from the a group of inputs.
window.inputsTotalValue = (inputArray) => {
  // Store total value.
  let total = 0;
  // Loop through input array.
  inputArray.each(function() {
      // Grab context.
      let input = $(this);
      // Input value.
      let value = parseInt((input.val() == "" ? 0 : input.val()));
      // Get value.
      total = (total + value);
  });
  return total;
}

// Work out remaining value of 2 numbers.
window.inputsRemainingValue = (maxValue, currentValue) => {
  // If max value exceeded then default to 0.
  if (currentValue > maxValue) {
    return 0;
  } else {
    return (Math.abs(parseInt(maxValue) - parseInt(currentValue)));
  }
}

// Difference between two ints.
window.intDiff = (valueA, valueB) => {
  if (typeof(valueA) != "number" && typeof(valueB) != "number") {
    console.error("Both values must be a number");
    return false;
  }
  return Math.abs(parseInt(valueA) - parseInt(valueB));
}

// Needed to convert rgb to hex found a simple solution here: https://stackoverflow.com/questions/1740700/how-to-get-hex-color-value-rather-than-rgb-value
window.rgb2hex = (rgb) => {
  if (  rgb.search("rgb") == -1 ) {
       return rgb;
  } else {
       rgb = rgb.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+))?\)$/);
       function hex(x) {
            return ("0" + parseInt(x).toString(16)).slice(-2);
       }
       return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]); 
  }
}

// ----- Popups ----- 
window.popupContainer = (content, ajax = false) => {
  // Generate unique id.
  let containerId = generateId();
  // Used for form popups where the fields need to me moved out of the form ( blurred background reasons ).
  if (!ajax) {
    content.wrap(`<div class="popup-original-position" popup-id="${containerId}"></div>`);
  }
  
  // Move content into new popup container.
  $('body').append(`<div class="popup-container" popup-id="${containerId}">
  </div>`);

  // Check if close button exists.
  if (content.find('.close-button').length == 0) {
    if (AXISDebug.level() >= 3) {
      AXISDebug.output(1,"Popup Container: Adding close button as popup has none.");
    }
    content.append("<button type='button' class='close-button'></button>")
  }
 
  content.appendTo('.popup-container[popup-id=' + containerId + ']');

  // Add Id + listener to close button.
  let closeButton = content.find('.close-button');
  closeButton.attr('close-popup', containerId);

  return containerId;
}

window.popupClose = () => {
  $('header, main, footer, .back-top-container').removeClass('blur');
  bodyScrollLock(true);
  return true;
}

// Simple test function to get an element into fullscreen mode.
window.elementFullscreenMode = (context) => {
  let element = context[0];
  let method = element.requestFullscreen;
  method.call(element);
}

// Common function for blurring the entire page ( i.e modals / popups ).
var blurRemoveTimeout = null;
window.blurContent = (context, removeBackgroundBlur = true) => {
  // Build selector for the content we're about to blur.
  let content = getBlurContent(context);
  // Blur overlay markup, used for click event that removes blur effect.
  let overlay = `<div class="blur-overlay" data-blur-overlay></div>`;
  if (content.hasClass('blur') && !blurRemoveTimeout) {
    disableBlur();
  } else {
    if (blurRemoveTimeout) {
      // Clear timeout as the blur functionality is now required against, this scenario is most likely a modal closing and a new one opening immediatly afterwards. 
      clearTimeout(blurRemoveTimeout);
      blurRemoveTimeout = 0;
      if (content.hasClass('defuse')) {
        content.removeClass('defuse');
      }
    }
    content.toggleClass('blur');
    // If blur overlay doesn't exist.
    if (!$('[data-blur-overlay]').length) {
      // Add it to DOM.
      $('body').append(overlay);
      // Add click listener.
      $('[data-blur-overlay]').on('click', function() {
        disableBlur();
      });
    }
  }

  function disableBlur() {
    // Get css blur value.
    let blur = content.css('filter');
    // Get animation.
    let animation = content.css('--defuse-animation');
    // Apply blur effect inline so when we removed the blur class the effect remains in position.
    content.css('filter', blur);
    // Begin defusing the blur effect.
    content.css('animation', animation);
    // Removed blur class.
    content.removeClass('blur');
    // Once finished animation then clean up inline styles.
    content.on('animationend', function() {
      // Clean up inline css.
      content.css('filter','');
      content.css('animation','');
      // Remove listener.
      content.off('animationend');
    });
    // if (!content.hasClass('defuse')) {
    //   // Defuse blur ( add animation for it's removal).
    //   content.addClass('defuse');
    //   // Wait X amount of time before fully disabling.
    //   blurRemoveTimeout = setTimeout(() => {
    //     // Remove blur.
    //     content.removeClass('blur defuse');
    //   }, 150);
    // }
    if (removeBackgroundBlur) {
       // If blur overlay exists.
      if ($('[data-blur-overlay]').length) {
        // Clear up listener.
        $('[data-blur-overlay]').off('click');
        // Removed it from DOM.
        $('[data-blur-overlay]').remove();
      }
    }
   
    // Trigger event.
    $(document).trigger('blur-disabled');
  }
}
// Work out which content needs to be blurred.
window.getBlurContent = (context) => {
  return (context ? (context.parents('header').length ? $('main, footer, .back-top-container') : context) : $('header, main, footer, .back-top-container'));
}
// Check whether blur is active? 
window.isBlurContentActive = (context) => {
  //return ($('[data-blur-overlay]').length ? true : false);
  return (context ? (context.parents('header').length ? $('main, footer').hasClass('blur') : context.hasClass('blur')) : $('header, main, footer, .back-top-container ').hasClass('blur'));
}

// Get window viewport dimensions.
window.getViewPortSize = () => {
  const width = window.innerWidth;
  const height = window.innerHeight;
  return {
    width: width,
    height: height
  };
}

// Check whether element is in viewport.
window.getViewPort = (context) => {
  let bounding = context.get(0).getBoundingClientRect();
  return (
    bounding.top >= 0 &&
    bounding.left >= 0 &&
    bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

window.getElementPosition = (context) => {
  return context.get(0).getBoundingClientRect();
}

// Tells us which side is overlaping the viewport.
window.getViewPortOverlapSide = (context) => {
  // Get positioning of element.
  let positioning = getElementPosition(context);
  // Get window width.
  let windowWidth = window.innerWidth;
  // Get Window height.
  let windowHeight = window.innerHeight;
  // Will hold which side we're overlapping.
  let overlappingSide = {};
  // Give back how much we're overlapping on each side.
  // If overlapping top.
  if (positioning.top < 0) {
    overlappingSide['top'] = positioning.top
  }
  // If overlapping right.
  if (positioning.right > windowWidth) {
    // Adding 20px to allow for scrollbar.
    overlappingSide['right'] = ((positioning.right - windowWidth) + 20);
  } 
  // If overlapping bottom.
  if (positioning.bottom >= window.innerHeight) {
    overlappingSide['bottom'] = ((positioning.bottom - windowHeight) + 20);
  }
  // If overlapping left.
  if (positioning.left < 0) {
    overlappingSide['left'] = Math.abs(positioning.left);
  }
  return overlappingSide;
}


/*
  Attempts to scroll the element into view.
  - context => element to scroll too.
  - options => i.e force scrolling.
*/
window.scrollIntoView = (context, options) => {
  if (!context) {
    AXISDebug.output(3,"Cannot find element to scroll too have you provided a context?", context);
    return false;
  }
  // Force scrolling whether in view or not.
  const force = (options.hasOwnProperty('force') ? options['force'] : false);
  // If element is already in view then exit.
  const overlap = getViewPortOverlapSide(context);
  if (overlap.hasOwnProperty('top') == false && !force) {
    if (AXISDebug.level() >= 3) {
      AXISDebug.output(1,"Element is already in view", context);
    }
    return false;
  }
  let position = context.offset().top;
  // Scroll into the center of the window.
  let windowHeight = $(window).height();
  // Is header stuck?
  let isStuck = isHeaderStuck();
  // Header size.
  let headerSize = getHeaderStuckSize();
  // Calculate position.
  //position = (position + headerSize) - (windowHeight / 1.75);
  // How much extra so scroll to make sure element is not tight against the header.
  let threshold = 150;
  position = (position - headerSize) - threshold;
  $('html, body').animate({
    scrollTop: position
  });
}


// Get the input type as val() doesn't work with checkbox's it always returns on.
window.getInputValue = (context) => {
  let type = context.attr('type');
  let value = undefined;
  if (type) {
      if (type == "checkbox" || type == "radio") {
        value = (context.is(':checked') ? 1 : 0);
      } else {
          value = context.val();
      }
  }
  return value;
}

// Check whether a string contains html.
window.containsHTML = (string) => {
   // Build regexp.
   let regex = new RegExp(/<\/?[a-z][\s\S]*>/, 'i');
   // Run test.
   return regex.test(string);
}

// File size byte converters.
// byte => KB
window.byteToKB = (value) => {
  return (value / Math.pow(1024, 1));
}
// byte => MB 
window.byteToMB = (value) => {
  return (value / Math.pow(1024, 2));
}
// byte => GB 
window.byteToGB = (value) => {
  return (value / Math.pow(1024, 3));
}
// Format file size.
window.formatFileSize = (value) => {
  let MB = byteToMB(value).toFixed(2);
  if (MB >= 1000) {
    return byteToGB(value).toFixed(2) + "GB";
  } else if (MB == 0) {
    return byteToKB(value).toFixed(2) + "KB";
  } else {
    return MB + "MB";
  }
}

// Write JSON to file.
window.writeJSONFile = (data, fileName) => {
  const rawJson = JSON.stringify(data, null, 2);
  const blob = new Blob([rawJson], { type: 'application/json' });
  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  link.download = `${fileName}.json`;
  link.click();

  URL.revokeObjectURL(url);
}

window.filenameFromHeaders = (jqXHR) => {
  const disposition = jqXHR.getResponseHeader('Content-Disposition') || '';
   // Extended form wins when present: filename*=UTF-8''percent%20encoded.csv
  const extended = disposition.match(/filename\*=(?:UTF-8'')?([^;]+)/i);
  if (extended) {
    return decodeURIComponent(extended[1].trim().replace(/^["']|["']$/g, ''));
  }
  // Plain form: filename="something.csv" or filename=something.csv
  const plain = disposition.match(/filename=["']?([^"';]+)["']?/i);
  if (plain) return plain[1].trim();
   return '';
} 

// Escape HTML.
window.escapeHtml = (string) => {
  const htmlEntities = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;'
  };
  return string.replace(/[&<>"']/g, function(char) {
    return htmlEntities[char];
  });
}

// Reverse an array.
jQuery.fn.reverse = [].reverse;

// Camelcase a string.
window.camelise = function camelise(string) {
  return string.replace(/\W+(.)/g, function(match, chr)
  {
      return chr.toUpperCase();
  });
}

// Toggle content loader spinner.
window.contentLoaderSpinnerToggle = (context, text = undefined, toggle) => {
  if (!context) {
    AXISDebug.output(3, "Content Loader Spinner: No context provided, where are we putting the spinner in the DOM?");
    return false;
  }

  // Fallback.
  if (!text) {
    if (context.attr(expressSelectors()['axis-content-loader-spinners']['text'])) {
      text = context.attr(expressSelectors()['axis-content-loader-spinners']['text']);
    }
  }
  // Check if spinner already exists.
  let spinnerContext = context.find('[' + expressSelectors()['axis-content-loader-spinners']['initialise'] + ']');
  // If already exists then remove it.
  if (!toggle) {
    spinnerContext.remove('[' + expressSelectors()['axis-content-loader-spinners']['initialise'] + ']');
    // Remove block class.
    context.addClass('content-block-active');
  } else {
    if (text) {
      text = `<div class="cms-content-container">
        <p>${text}</p>
      </div>`;
    }
    // Create markup.
    let markup = `<div class="initialising-content-blocker-container" ${expressSelectors()['axis-content-loader-spinners']['initialise']}>
        <div class="spinner"></div>
        ${(text ? text : "")}
    </div>`;
    // Add blocker.
    context.append(markup);
    // Add block class.
    context.addClass('content-block-active');

  }
}

// Generic focus element.
window.focusElement = (context) => {
  if (!context)  {
    AXISDebug.output(3,"Focus Element: Please provide the context of the element you wish to focus.", context);
    return false;
  }
  return context.trigger('focus');
}

// Attempt to parse JSON.
window.parseJSON = (string) => {
  if (!string) {
    AXISDebug.output(3,"Parse JSON: No string provided");
    return false;
  }
  if (typeof(string) == 'object') {
    if (AXISDebug.level() >= 3) {
      AXISDebug.output(1,"Parse JSON: Already a JSON object")
    }
    return string;
  }
  try  {
    let json = JSON.parse(string);
    return json;
  } catch(error) {
    AXISDebug.output(3,error);
    return false;
  }
}

// Get domain from URL string, based on selected answer https://stackoverflow.com/questions/34818020/javascript-regex-url-extract-domain-only
window.getDomainFromUrl = (url) => {
  if (!url) {
    console.error("Domain From String: No url provided", url);
    return false
  }
  let result;
  let regex = new RegExp(/^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:\/\n\?\=]+)/im);
  result = regex.exec(url);
  // If url exists.
  if (result) {
    result = result[1];
  }
  return result;
}

// Convert milliseconds to hours.
window.convertMillisecondsToHours = (milliseconds) => {
  let hours = Math.floor(milliseconds / 3600000); 
  return hours;
}

/* Callback Container 

This was previous nested within axis-ajax.js which was only invoked when a callback occurred but had to be made more modular due to a timing issue when Executing reCAPTCHA where jQuery.wrap causes the DOM to reflow & re-paint whilst Google's library as accessing the DOM causing the Execute Method to silently fail #859210.

*/
window.callbackContainerClass = "callbackContainer";
window.callbackContainerTemplate = `<div class="${callbackContainerClass}"></div>`;

// Get callback container.
window.getResponseCallbackContainer = (context) => {
  if (!context.length) {
    AXISDebug.output(3, "Get Callback Container: Please provide a context elmeent");
    return false;
  }
  let container = context.closest('.' + callbackContainerClass);
  if (!container.length) {
    AXISDebug.level(2, "Get Callback Container: Container not found", context);
  }
  // Check if a specific container has been configured ( i.e could be wrapped in context ).
  if (!container.length) {
    const callbackContainerId = context.attr(expressSelectors()['ajax']['callback-container-id']);
    if (callbackContainerId) {
      // Find in DOM, there maybe an opertunity to use memory to get container context but there is a risk that container context could have been replaced by the response ( i.e JSON update).
      container = $('#' + callbackContainerId);
      if (!container.length) {
        AXISDebug.level(2, "Get Callback Container: Failed to get container by Id", context);
      }
    }
  }
  return container;
}

// Add callback container around an element ( i.e a form ).
window.setResponseCallbackContainer = (context) => {
  if (!context.length) {
    AXISDebug.output(3, "Set Callback Container: Please provide a context elmeent");
    return false;
  }
  const isForm = context.is('form');
  const isModal = (context.attr(expressSelectors()['modals']['modal-context']) != undefined);
  let container = "";
  if (isForm) {
    context.wrap(callbackContainerTemplate);
  } else if (isModal) {
    // Find the inject container.
    const injectContainer = context.find('[' + expressSelectors()['modals']['inject-container'] + ']');
    if (injectContainer.length) {
      // Use the inject container as the response container.
      container = injectContainer;
    } else {
      AXISDebug.output(2, "Set Callback Container: Couldn't find inject container in modal");
    }
  } else {
    context.wrap(callbackContainerTemplate);
  }
  if (!container.length) {
    // Get container context.
    container = getResponseCallbackContainer(context);
    if (!container.length) {
      AXISDebug.output(2, "Set Callback Container: Couldn't find container", context);
    }
  }
  return container;
}

// Iframes
window.frameResize = (frameId, dimensions) => {
  if (!frameId) {
    AXISDebug.output(3,"Frame Resize: No Iframe Id provided.");
    return false;
  }
  const width = (dimensions.hasOwnProperty('width') ? dimensions['width'] : null);
  const height = (dimensions.hasOwnProperty('height') ? dimensions['height'] : null);
  if (!width || !height) {
    AXISDebug.output(3,"Frame Resize: Invalid dimensions provided");
    return false;
  }
  // Find frame.
  const frame = $('iframe#' + frameId);
  // Set CSS properties.
  frame.css('width', width);
  frame.css('height', height);
  return true;
}

// Default callout open time, this is used for the side callouts for button / form validation.
window.calloutDefaultOpenTime = 6000;


// Set global variables so classes can add additional plugins / buttons to editor configurations.
window.toolbarExtraButtons = [];
window.editorExtraPlugins = [];

// Common Intersection Observer Contructor options.
window.commonIntersectionObserverOptions = {
  "callback-visibility-threshold": [0, 0.25, 0.5, 0.70, 0.80, 0.90, 1],
  "min-visible-radio": .7
} 

// Express selectors.
window.expressSelectors = () => {
  let selectors = {};
  // --- Modules --- 
  let modules = {};
  // Collections
  modules['equalise-modules'] =  ".product-grid-module, .image-grid-module";
  // deprecated
  modules['grid'] = ".product-grid-module, .image-grid-module";
  // deprecated
  modules['collection-item-image'] = ".content-container.product > a:first-of-type .image";
  // deprecated
  modules['collection-item-description'] = ".product-grid-module";
  // CMS
  modules['cms'] = '.cms-module'
  selectors['modules'] = modules;
  // --- CMS ---
  let cms = {};
  // Tables
  cms['tables'] = ".cms-entry-container table:not([data-responsive-table-ignore]), .cms-module table:not([data-responsive-table-ignore]), #tabbed-notes-container table:not([data-responsive-table-ignore])";
  selectors['cms'] = cms;
  // --- Tables ---
  let tables = {};
  // Responsive tables - add stack class and create mobule col-labels.
  tables['responsive-tables'] = "responsive-table";
  // Table scrollable - can we scroll the contents of the table with the thead sticking to the top of the container.
  tables['table-scrollable'] = "data-table-scrollable";
  // Table container.
  tables['table-container'] = "data-table-container";
  // Responsive reveal - in mobile display the table more like an accordion.
  tables['responsive-table'] = "responsive-reveal";
  // The column label in mobile that gets copied from the desktop header.
  tables['mobile-label'] = "data-column-label";
  // Mobile Column Label Ignore Ignore column label in mobule.
  tables['mobile-label-ignore'] = "data-mobile-column-label-ignore";

  // Responsive header item - which columns to be show in header reveal section in mobile if table = responsive table.
  tables['responsive-header-item'] = "responsive-header-item";
  // Comparison Table - allows for a side nav column as well as a header row.
  tables['comparison-tables'] = "comparison-table";

  tables['row-input-toggle'] = "data-row-input-toggle";
  selectors['tables'] = tables;
  // --- Product List ---
  let productList = {};
  // Filters
  productList['filters'] = "#filters";
  productList['filter-price-slider'] = "#price-slider";
  // Grid
  productList['list'] = "#productListItems"; 
  selectors['product-list'] = productList;

  // Mapping out the concept of variables for product lists
  // let productsList = {};
  // Initialise.
  // productsList['initialise'] = "data-product-list";
  // List container - this will have the actual list, sorting options & filters.
  // productsList['components-container'] = "data-list-components-container";
  // Filters container.
  // productsList['filters-container'] = "data-list-filters-container";
  // Sticky filter toggle
  // selectors['axis-products-list'] = productsList;


  // --- Product ---
  let product = {};
  // Light box
  //product['lightbox'] = ".lightbox";
  // Additional Images.
  //product['additional-images'] = "#additional-images";
  // Stock line controls.
  //product['stockline-controls'] = "[data-stockline-controls]";
  selectors['product'] = product;
  // --- Stocklines ---
  let stockline = {};
  // Initialise.
  stockline['initialise'] = "data-stockline-controls";
  selectors['axis-stockline'] = stockline;
  // --- Magnification ---
  let magnifiation = {};
  // Initialise.
  magnifiation['initialise'] = "data-magnification";
  selectors['axis-magnifier'] = magnifiation;
  // --- Light Box --- 
  let lightbox = {};
  // Iniitalise.
  lightbox['initialise'] = "data-lightbox";
  // Lightbox trigger
  lightbox['trigger'] = "data-lightbox-trigger";
  // Header - link header to instance.
  lightbox['header'] = "data-lightbox-header";
  selectors['axis-lightbox'] = lightbox;
  // --- Additional Images --- 
  let additionalImages = {};
  // Initialise.
  additionalImages['initialise'] = "data-additional-images";
  selectors['axis-additional-images'] = additionalImages;
  // --- Youtube Player --- 
  let youtube = {}
  // Initialise
  youtube['initialise'] = "data-youtube-player";
  // Video Url
  youtube['url'] = "data-video-url";
  // Start position.
  youtube['start-position'] = "data-start-position";
  // End position.
  youtube['end-position'] = "data-end-position";
  // Video controls.
  youtube['controls'] = "data-video-controls";
  selectors['axis-youtube-player'] = youtube;
  // --- 360 Images ---
  let image360 = {};
  // Initialise.
  image360['initialise'] = "data-image-360";
  selectors['axis-image-360'] = image360;
  // --- Countdown  --- 
  let countdown = {};
  // Initialise.
  countdown['initialise'] = "data-countdown-time"
  selectors['axis-countdown'] = countdown;
  // --- Stock Indicators --- 
  let stockIndicators = {};
  // Initialise attribute.
  stockIndicators['initialise'] = ".stock-indicator.soh-0 a";
  // Instance - get stock indicator instance.
  stockIndicators['instance'] = "stock-indicator-id";
  // Update - update all stock with this reference.
  stockIndicators['update'] = "data-stock-indicator-update";
  selectors['stock-indicators'] = stockIndicators;
  // --- Forms --- 
  let forms = {};
  // AJAX initialiser for forms.
  forms['ajax-form'] = "form.prompt, [data-ajax-form]";
  // // reCaptcha.
  // forms['recaptcha'] = "data-captcha-type";
  // Auto submit - this will automatically post back to the server if a change has been made.
  forms['auto-submit'] = "data-auto-submit";
  // Include context - sends addtiional form information to the server rading fields ( labels + sequence ) this is primarily for sending form data in emails.
  forms['include-context'] = "data-include-context";
  // Input label - if include context enabled and we're sending hidden variables that do not have a .label ( i.e not a plain text input ) this this attribute acts as a fallback to not having an assign .label present.
  forms['input-label'] = "data-input-label";
  // Position reset 
  forms['position-reset'] = "data-position-reset";
  // Input Group id - used to group inputs together, this goes on the container of the inputs that are going to be grouped or the parent input.
  forms['input-group-id'] = "data-input-group-id";
  // Conditional input - essentially optional inputs depending on whether this one is checked.
  forms['conditional-input'] = "data-conditional-input";
  // Conditional reset - when uncheck also uncheck any children in the data-conditional-input-container.
  forms['conditional-reset'] = "data-conditional-reset";
  // group-id - goes on the child input to associate it with a group.
  forms['group-id'] = "data-group-id";
  // Group error - the error that gets show when the group fails group validation.
  forms['group-error'] = "data-group-error";
  // Group Max - this is the maximum value of a group of inputs.
  forms['group-max'] = "data-group-max";
  // Group Min - this is the minimum value of a group of inputs.
  forms['group-min'] = "data-group-min";
  // Min required - this is the old way of thinking where put the min-requred attribute on every input instead of just the parent / container.
  forms['min-required'] = "data-min-required";
  // Group multiple - the total value of the group must be a multiple of x.
  forms['group-multiple'] = "data-group-multiple";
  // Selected Count - displays the total of items selected.
  forms['selected-count'] = "data-group-selected-count";
  // Remaining count - displays the remaining items to select count.
  forms['remaining-count'] = "data-group-remaining";
  // Unsave changes - if there are any changes on the form and the user is able to navigate away fire confirm modal.
  forms['unsaved-changes'] = "data-unsaved-changes";
  // Serialise Active Only - only serialise items that have the option-active attribute.
  forms['serialise-active-only'] = "data-serialise-active-only";
  // Option Active - when data-serialise-active-only is active only elements with this attribute get serialised.
  forms['option-active'] = "data-option-active";
  // Force all data-option-active controls to submit, include the conditional onces.
  forms['option-active-force'] = "data-option-active-force-all";
  // Only serialise options with this attribute if 
  forms['option-active-conditional'] = "data-option-active-conditional";
  // Checkbox group toggle all - if the parent checkbox is toggled then toggle all children.
  forms['checkbox-toggle-all'] = "data-toggle-all";
  // Checkbox group parent toggle - if a child checkbox is checked then check parent if none then uncheck parent.
  forms['checkbox-parent-toggle'] = "data-parent-toggle";
  // Suppress live validation on forms so only when the form is submitted the user sees the error messages but when an input is invalidated then corrected remove the error.
  forms['suppress-live-validation'] = "data-suppress-live-validation";
  // Whether to import a form.
  forms['load'] = "data-form-load";
  // Include additional form when serialising.
  forms['additional-form'] = "data-include-additional-form";
  // Used for inputs to give generic value.
  forms['input-unique-value'] = "data-generate-unique-value";
  // Bind one form's data with another.
  forms['data-bind'] = "data-form-bind";
  // Element that get used to display a form input's value.
  forms['data-bind-placeholder'] = "data-form-bind-placeholder";
  // Old conditional mechanism, use group validation instead.
  forms['depends'] = "data-depends";
  forms['accordion-tabs-update'] = "data-responsive-accordion-tabs-update";
  // Controls.
  let controls = forms['controls'] = {};
  // File instance - the instance id for the file control input.
  controls['file-instance'] = "control-file-upload-id";
  // File remove text - the text that gets show when a file is ready to upload.
  controls['file-remove-text'] = "file-remove-text";
  // File upload text - when a file is ready to be upload.
  controls['file-upload-text'] = "file-upload-text";
  // Invalid file text - the file that has been selected type is invalid.
  controls['file-invalid-text'] = "file-error-text";
  // File remove - this attribute can be placed on button's to signal when to remove the file.
  controls['file-remove'] = "data-remove-file";
  // Invalid reason - the reason why the anchor / button has been disabled.
  controls['invalid-reason'] = "data-invalid-reason";

  // Restricted content - if content disabled then show a message, if this is an input pass in the id as a value of a element you want to disable.
  controls['restricted-content'] = "data-restricted-content"
  // Restricted content text - what get shown in the call out if the user clicks the button.
  controls['restricted-content-text'] = "data-restricted-content-text";
  // Custom input - links dropdown custom input with text input.
  controls['dropdown-custom-input'] = "data-custom-input";
  // Custom input container.
  controls['dropdown-custom-input-container'] = "data-custom-input-container";
  // Focus - focus an input automatically.
  controls['focus'] = "data-focus-element";
  // Validation
  let validation = forms['validation'] = {};
  // File Accept - If the input is of type file then what files does it accepts? 
  validation['file-accept'] = "accept";
  // File size - the file size limit that a file upload area is restricted by.
  validation['file-size'] = "data-file-size-limit";
  // Callout error - if the input doesn't have enough space to display the normal form error then display the error in a callout ( quantity selectors )
  validation['callout-error'] = "data-callout-error";
  // Captcha
  validation['captcha-type'] = "data-captcha-type";
  // Form Error For - Looks for an attribute that has the same value as the input's Id, this is primary used when the error cannot be placed next to the field.
  validation['external-error'] = "data-form-error-for";
  selectors['forms'] = forms;
  // --- Captcha ---
  let captcha = {};
  // Initialise
  captcha['initialise'] = "data-captcha-type";
  selectors['axis-captcha'] = captcha;
  // --- Ajax --- 
  let ajax = {};
  // Instance.
  ajax['instance'] = "data-ajax-id";
  // AJAX URL - Typically " data-ajax " is used to initalise an instance + provide a url but we're starting to get name conflictions for exmaple modals and lookups due to lookups binding to any button with data-ajax so data-ajax-url was introduced to be more specific.
  ajax['url'] =  "data-ajax-url";
  // Operation - what action/operation you're about to perform.
  ajax['operation'] = "ajax-operation";
  // Data type - The type of data that you're expecting back from the server. 
  ajax['data-type'] = "data-ajax-data-type";
  // Data Method - This is used as a fallback if you're not ajax'ing content into a form where you can use the " method " attribute.
  ajax['method'] = "data-ajax-method";
  // Update Content - Used to update other elements of the DOM outside of the callback container.
  ajax['update-content'] = "data-update-content";
  // Update breadcrumbs.
  ajax['update-breadcrumbs'] = "data-update-breadcrumbs";
  // Observer - User to watch for nodes that get updated due to the callback so then the content can get initialised, this accepts a comma seperated list of Id's.
  // DEPRICATED use response-context
  ajax['observer-target'] = "data-ajax-initialisation-observer";

  // Response context is used when you're putting the response outside of the .callBackContainer, this will do both provide the location in the DOM to update + tell the js re-initialiser function the container(s) that it needs to update, you can pass in a comma seperated list of element Id's or just a single Id ( this was pre - updating via json ) you should use that instead.
  ajax['response-context'] = "data-ajax-context";

  // Callback Container Id - the of the call back container this should get use if the container is not directly wrapping the data-ajax or form.
  ajax['callback-container-id'] = "data-callback-container-id";
  // Have had to add suppression toggle due to call to feefo api (787342) not liking the additional parameter.
  ajax['suppress-ajax-flag'] = "data-ajax-suppress-ajax-flag";
  // Content blocker delay - primary used for static build to " simulate " a slow server response.
  ajax['content-blocker-delay'] = "data-content-blocker-delay";
  // Focus on an element in the response.
  ajax['response-focus-element-id'] = "data-ajax-response-focus";
  // Content block element.
  ajax['content-block-element'] = "data-ajax-content-block";
  // Content block container.
  ajax['content-block-container'] = "data-ajax-content-block-container";
  // Allow user to navigate away mid callback.
  ajax['ignore-active-unload-prompt'] = "data-ajax-ignore-active-unload-prompt";
  // When submitting product list sorting vMerchant needs additional context, this comes in the form of a variable name + value.
  ajax['vm-context-variable'] = "data-context-variable";
  ajax['vm-context-value'] = "data-context-value";
  selectors['ajax'] = ajax; 
  // --- Update Url ---
  selectors['update-url'] = "data-update-url";
  // --- Lookups ---
  let lookups = {};
  // Initialise selector(s).
  lookups['initialise'] = "button[data-ajax], select[data-ajax], input[data-ajax]";
  // Holds lookup instance id.
  lookups['instance'] = "data-lookup-id";
  // Ignore form Data - if data-ajax-context is defined for updating somewhere else in the DOM but you don't want to pass any form data that maybe inside of it.
  lookups['ignore-form-data'] = "data-lookup-ignore-form";
  // Ajax context - A container with form inputs nested that will get serialised when a callback is requested, this mechanism was also for defining where to put the lookup's response which has not been superseeded by data-callback-container-id.
  lookups['ajax-content'] = "data-ajax-context";
  // Lookup key - Input that is assigned tot he input.
  lookups['lookup-key'] = "data-lookup-key";
  selectors['lookups'] = lookups;
  // --- Predictive Search --- 
  let predictiveSearch = {};
  // Initialise.
  predictiveSearch['initialise'] = "data-ajax-search";
  // Results search - the search input that gets placed in the results.
  predictiveSearch['results-search'] = "data-results-search";
  selectors['axis-predictive-search'] = predictiveSearch;
  // --- Quantity Selectors ---
  let quantitySelector = {};
  // Initialise attribute / class.
  quantitySelector['initialise'] = ".input-number";
  // Incrementor - the element that gets used to increment the value in the free text input.
  quantitySelector['incrementor'] = ".input-number-increment";
  // Deincrementor - the element that gets used to deincrement the value in the free text input.
  quantitySelector['deincrementor'] = ".input-number-decrement";
  selectors['quantity-selector'] = quantitySelector;
  // --- Basket --- 
  let basket = {};
  // Basket page form context.
  basket['form'] = '#basket-form';
  // Basket page content container.
  basket['basket-page-content-container'] = "#basket-content-container";
  // Trigger basket add from a parent element.
  basket['add-parent-container'] = "data-basket-add-parent";
  // Basket update trigger - add to basket buttons.
  basket['add-trigger'] = "addButton, .add-to-basket, .addToBasketButton, .addToBasket,.AXISPicknMixSubmit, #checkoutBasketUpdate, [basket-add]";
  // Add to basket form ( this is also a trigger ) - essentially the quantity selector that belongs to an spcific item.
  basket['add-form'] = '.quantity-container, [data-add-to-basket-form]';
  // Basket update trigger.
  basket['update-trigger'] = ".update-basket, [basket-update]";
  // Basket remove trigger - removes a specific item from the basket.
  basket['remove-trigger'] = ".remove-button, [basket-remove]";
  // Get the item id.
  basket['product-id'] = "data-product-id";
  // Get the item reference.
  basket['product-reference'] = "data-product-reference";
  // Basket clear trigger - removes ALL items from the basket.
  basket['clear-trigger'] = '.empty-basket, [basket-empty]';
  // Basket Summary.
  basket['summary'] = "data-summary-container";
  // Basket summary container - used for working out the position of the update popup..
  basket['summary-container'] = "data-header-basket-container";
  // Basket Item Count - just count of how many items are in the basket.
  basket['item-count'] = "data-basket-item-count";
  // Basket total value - total value of the contents of the basket.
  basket['total-value'] = "data-basket-total-value";
  // Recently added container.
  basket['summary-recently-added'] = "data-summary-recently-added";
  // Recently updated pause - when toggled how long does the popup stay open.
  basket['recently-updated-pause'] = "data-update-basket-pause";
  // Notification container.
  basket['summary-notifications-container'] = " data-basket-summary-notifications";
  // What sort of notification are in the container.
  basket['summary-notification-type'] = "data-notification-type";
  selectors['basket'] = basket;
  // --- Sliders ---
  let slider = {};
  // Initialise attribite.
  slider['initialise'] = "[data-slider]";
  selectors['slider'] = slider;
  // ---- Footer --- 
  let footer = {};
  // The footer menu / list selector.
  footer['menu'] = "#footerNavigationList";
  selectors['footer'] = footer;
  // --- Modals --- 
  let modals = {};
  // Modal context.
  modals['modal-context'] = "data-modal";
  // Inject content - context of the content you're about to inject.
  modals['inject-content'] = "data-content";
  // Modal Lock - prevent the modal from being closable ( temporarily ).
  modals['locked'] = "data-modal-locked";
  // Proceed button.
  modals['proceed-button'] = ".prompt-proceed-button";
  // Close elements.
  modals['close'] = ".modal-background, .close-button, .prompt-proceed-button, .prompt-cancel-button, .prompt-close";
  // Close modal- Used after ajax to close the last used modal.
  modals['close-modal'] = "data-close-modal";
  // Open modal - opens a specific modal progmattically without triggering a click event.
  modals['open-modal'] = "data-open-modal";
  // Close Suppress - suppresses both close on click + escape
  modals['close-suppress'] = "data-close-suppress";
  // Close on click - toggle whether to close on background click.
  modals['close-on-click'] = "data-close-on-click";
  // Close on escape - toggle whether to close on escape key press.
  modals['close-on-escape'] = "data-close-on-escape";
  // Iframe src 
  modals['iframe-src'] = "data-iframe-src";
  // Modal Id - used for defining an instance.
  modals['modal-id'] = "data-modal-id";
  // Include form - includes a form data as part of the query string for ajax modals.
  modals['include-form'] = "data-include-form";
  // Input - currently only for ajax modal for when you hit enter on an element and expect the modal to trigger.
  modals['input'] = "data-modal-ajax-input";
  // Inject container - if using an ajax modal then there needs to be an inject container inside of of it for the response to be dropped into.
  modals['inject-container'] = "inject-container";
  // Confirm - confirm modal trigger.
  modals['confirm'] = "data-modal-confirm";
  // Confirmed - If the user has gone through the confirmation then the trigger button is marked with this attribute = true.
  modals['confirmed'] = "data-modal-confirmed";
  // Confirm accept button - This was originally implemented using .prompt-proceed-button, with the attribute being added later, so both selectors are to be supported.
  modals['accept-button'] = "data-accept-button";
  // Modifies when the modal is triggered if there is already active modals.
  modals['queue-behaviour'] = "data-queue-behavior";
  // Modal priority used for z-index'ing multiple active modals.
  modals['priority'] = "data-modal-priority";
  // Modal for static content.
  modals['static'] = "data-modal-static";
  selectors['modals'] = modals;
  // --- Carousels ---
  let carousel = {};
  // Initialise.
  carousel['initialise'] = "data-bxslider";
  // Instance Id.
  carousel['instance'] = "bx-slider-id";
  selectors['axis-carousel'] = carousel;
  // --- Callouts --- 
  let callouts = {};
  // Initialise.
  callouts['initialise'] = "data-callout";
  // Check for delay.
  callouts['delay'] = "data-close-delay";
  // Check the type of callout we want to display.
  callouts['type'] = "data-type";
  selectors['callouts'] = callouts;
  // --- Tooltip ---
  let tooltip = {};
  // -- Initialise.
  tooltip['initialise'] = "[data-tooltip]";
  // Container.
  tooltip['container'] = ".tooltip-container";
  // Trigger - what actually enables to the tooltip.
  tooltip['trigger'] = ".tooltip-trigger";
  // Content - the content that gets shown in the tooltip.
  tooltip['content-container'] = ".tooltip-content";
  // Event - the event that triggers the tooltip.
  tooltip['event'] = "tooltip-event-trigger";
  // Instance - the instance id.
  tooltip['instance'] = "tooltip-id";
  selectors['tooltip'] = tooltip;
  let clientSearch = {};
  // Initialise - attribute that gets used to initialise.
  clientSearch['initialise'] = "data-client-search";
  // Submit button - for submitting the search.
  clientSearch['submit-button'] = "data-client-search-button";
  // Content - the content that gets searched.
  clientSearch['content'] = "data-client-search-content";
  // Search item.
  clientSearch['item'] = "data-client-search-item";
  // No results.
  clientSearch['no-results'] = "data-client-search-no-results-found";
  selectors['client-search'] = clientSearch;
  // vmAdmin v2 prototype.
  let admin = {};
  // Initialise attribute.
  admin['initialise'] = "data-edit-id";
  // Type - what type of content is this? 
  admin['text-editor-type'] =  "edit-type";
  // Url - where we callback too.
  admin['url'] = "data-edit-url";
  // Edit context - used to pass server context string back to server.
  admin['edit-context'] = "data-edit-context"
  selectors['axis-admin'] = admin;
  // Style guide.
  let styleguide = {};
  // Colour pallette initialise.
  styleguide['colour-pallette'] = "data-style-guide-colour-pallette";
  // Colour preview - the element that shows a colour.
  styleguide['colour-preview'] = "data-colour-preview";
  // Continer for Style guide headings
  styleguide['css-properties'] = "data-style-guide-css-properties";
  // Heading - The actual heading.
  styleguide['property'] = "data-css-property";
  selectors['style-guide'] = styleguide;
  // Axis sticky
  let axisSticky = {};
  axisSticky['initialise'] = "data-axis-sticky";
  selectors['axis-sticky'] = axisSticky;
  // Table of contents
  let tableOfContents = {};
  // Initialise
  tableOfContents['initialise'] = "table-of-contents";
  // Table of contents section
  tableOfContents['section'] = "table-of-contents-section";
  selectors['table-of-contents'] = tableOfContents;
  // Equaliser.
  let equaliser = {};
  // Initialise.
  equaliser['initialise'] = "data-equalise-container";
  // Group Id - links element together.
  equaliser['group-id'] = "data-equalise-group";
  // Equalise by row.
  equaliser['by-row'] = "data-equalise-by-row";
  // Equalise X - equalise the width instead of height.
  equaliser['equalise-x'] = "data-equalise-x";
  // Equalise by min - Equalise by the min value in group.
  equaliser['equalise-by-min'] = "data-equalise-by-min";
  // Equalise breakpoint - Which breakpoint are we start equalising at.
  equaliser['breakpoint'] = "data-equalise-breakpoint";
  selectors['equaliser'] = equaliser;
  // Back to top.
  let backToTop = {};
  // Initialise
  backToTop['initialise'] = "data-back-to-top";
  // Trigger distance - how far form the top of the view port.
  backToTop['trigger-distance'] = "data-trigger-distance";
  // Animation duration for scrolling back to the top.
  backToTop['animation-duration'] = "data-animation-duration";
  selectors['back-to-top'] = backToTop;
  // Animiations.
  let animations = {};
  // Initialise.
  animations['initialise'] = "data-animation"
  selectors['axis-animations'] = animations;
  // Sections
  let sections = {};
  // Initialise.
  sections['initialise'] = "data-section";
  // Breakpoint - when to enable functionality.
  sections['breakpoint'] = "data-section-breakpoint";
  // Section header - the text that gets shown the section is closed.
  sections['header'] = "data-section-header";
  // Section content - this is what gets hidden when the section is not active.
  sections['content'] = "data-section-content";
  // Section buttons.
  sections['buttons'] = "data-section-buttons";
  // Disabled reason.
  sections['disabled-reason'] = "data-disabled-reason";
  // Open on load.
  sections['open-on-load'] = "data-section-open-by-default";
  selectors['sections'] = sections;
  // Ellipsis.
  let ellipsis = {};
  // Initialise.
  ellipsis['initialise'] = "data-ellipsis";
  // Breakpoint - when to enable functionality.
  ellipsis['breakpoint'] = "data-ellipsis-breakpoint";
  // Mode - whether to scroll or have tooltip.
  ellipsis['mode'] = "data-ellipsis-mode";
  selectors['ellipsis'] = ellipsis;
  // Content refresh.
  let contentRefresh = {};
  // Initialise.
  contentRefresh['initialise'] = "data-content-refresh";
  // Timers - How long between intervals.
  contentRefresh['timer'] = "data-refresh-timer";
  // Start timer.
  contentRefresh['start'] = "data-start-refresh-timer";
  // Stop timer.
  contentRefresh['stop'] = "data-stop-refresh-timer";
  selectors['content-refresh'] = contentRefresh;
  // DEPRICATED: Using axis-table-column-equaliser instead.
  // Text Equaliser
  // let tableTextEqualiser = {};
  // // Initialise
  // tableTextEqualiser['initialise'] = "data-text-equalise";
  // // Instance Id.
  // tableTextEqualiser['instance-id'] = "data-table-column-equalise"
  // // Column header.
  // tableTextEqualiser['column-heading'] = "data-column-header-content";
  // // Responsive start - which breakpoint should we enable this functionality from.
  // tableTextEqualiser['responsive-start'] = "data-breakpoint";
  // selectors['text-equaliser'] = tableTextEqualiser;
  // Table Column Equaliser.
  let tableColumnEqualiser = {};
  // Initialise.
  tableColumnEqualiser['initialise'] = "data-text-equalise";
  // Instance Id.
  tableColumnEqualiser['instance-id'] = "data-table-column-equalise"
  // Column header.
  tableColumnEqualiser['column-heading'] = "data-column-header-content";
  // Responsive start - which breakpoint should we enable this functionality from.
  tableColumnEqualiser['responsive-start'] = "data-breakpoint";
  selectors['axis-table-column-equaliser'] = tableColumnEqualiser;
  // Mega Menua
  let megaMenu = {};
  // Initialise.
  megaMenu['initialise'] = "data-mega-menu";
  // Container.
  megaMenu['container'] = "data-mega-menu-container";
  // Get group image source.
  megaMenu['group-image-src'] = "data-group-image";
  // Get group image context.
  megaMenu['group-image-context'] = "data-menu-ebg-image";
  // Column wrap - whether to span children to the next column.
  megaMenu['column-wrap'] = "data-column-wrap";
  // Group items that have no children together.
  megaMenu['group-childless'] = "data-group-childfree-submenus";
  // View more anchor - takes the user to view more EBG's.
  megaMenu['view-more-link'] = "data-menu-view-more";
  // Always show EBG images in the dropdown instead of on hover and taking up a column.
  megaMenu['persistent-ebg-images'] = "data-persistent-ebg-images";
  // persistant image container.
  megaMenu['persistent-image-container'] = "data-persistent-image-container";
  selectors['mega-menu'] = megaMenu;
  // Tree Menu
  let treeMenu = {};
  // Initialise.
  treeMenu['initialise'] = "data-tree-menu";
  // Node Content - the content of the node inside of a tree.
  treeMenu['node-content'] = "data-node-content-container";
  // Expand all alerts - expands all alert nodes.
  treeMenu['show-all-alerts'] = "data-alert-expand-all";
  // Node alert - the node that has the actual alert.
  treeMenu['alert-node'] = "data-node-alert";
  // Expand tree - expands the entire tree
  treeMenu['expand-tree'] = "data-tree-expand-all";
  // Expand all text 
  treeMenu['expand-all-text'] = "data-tree-expand-text";
  // Condense all text.
  treeMenu['condense-all-text'] = "data-tree-condense-text";
  // Open by default - open node on load.
  treeMenu['open-by-default'] = "data-node-open-by-default";
  selectors['axis-tree-menu'] = treeMenu;  // Geolocation.
  let geolocation = {};
  // Initialise -  the element that triggers the lookup process, this must have the Id of the inputs that holds the longitude.
  geolocation['initialise'] = "data-geolocation";
  // Longitude input
  geolocation['longitude-input'] = "data-longitude-input";
  // Latitude input
  geolocation['latitude-input'] = "data-latitude-input";
  // Accuracy input.
  geolocation['accuracy-input'] = "data-accuracy-input";
  // Search input
  geolocation['search-input'] = "data-search-input";
  selectors['geolocation'] = geolocation;
  // Interactive Map.
  let interactiveMaps = {};
  // Initialise.
  interactiveMaps['initialise'] = "data-interactive-map";
  // Type - what service are we using?
  interactiveMaps['type'] = "data-interactive-map-type";
  // Config - map configuration default latitude + longitude, default zoom, ect.
  interactiveMaps['config'] = "data-interactive-map-config";
  // Search results container.
  interactiveMaps['search-results'] = "interactive-map-results";
  // No search results container.
  interactiveMaps['no-results'] = "interactive-map-no-results-found";
  // Marker trigger - triggers the markers / pins on the map to show their info windows.
  interactiveMaps['marker-trigger'] = "data-interactive-map-location";
  selectors['axis-interactive-maps'] = interactiveMaps;
  let googleCloudApi = {};
  // api-key - this allows you to access google cloud's api library.
  googleCloudApi['api-key'] = "data-google-cloud-api-key";
  selectors['google-cloud'] = googleCloudApi;
  let reviews = {};
  // Initialise.
  reviews['initialise'] = "data-reviews"
  // widget - whare are we displaying? product summary or product reviews?
  reviews['widget'] = "data-reviews-widget";
  // sku - if this is a product review define the sku.
  reviews['sku'] = "data-reviews-product-sku";
  // Load on trigger - the id of the trigger.
  reviews['load-on-click'] = "data-reviews-load-on-click";
  // The trigger itself with the id.
  reviews['trigger'] = "data-reviews-trigger";
  // Reviews Uniquie Identifier - API Key / merchant identifier.
  reviews['key'] = "data-reviews-key";
  // Reviews type - the service you want to use?
  reviews['type'] = "data-reviews-type";
  // Reviews text entries.
  reviews['text-entries'] = "data-reviews-text-entries";
  // Notification panel - essentially on-page-notification area where any errors / no results found text gets outputted.
  reviews['notification-panel'] = "data-reviews-notification-panel";
  // Review attribute container - used to tally up how many review's we're currently showing.
  reviews['review-container'] = "data-reviews-review-container";
  // Page size - how many reviews are return in each callback.
  reviews['page-size'] = "data-reviews-page-size";
  selectors['axis-reviews'] = reviews;  
  let paintSelector = {};
  // Initialise.
  paintSelector['initialise'] = "data-paint-selector";
  // Key - API Key, Merchant Id or Vendor Id / name.
  paintSelector['key'] = "data-akzonobel-api-key";
  // Who is our provider.
  paintSelector['type'] = "data-paint-selector-type"
  // Text Entiries.
  paintSelector['text-entries'] = "data-paint-selector-text-entries";
  // Config ( i.e textdb & ajax )
  paintSelector['config'] = "data-paint-selector-config"
  // Allow search
  paintSelector['show-search'] = "data-show-search";
  // Colour collection dropdown.
  paintSelector['colour-collection'] = "data-show-colour-collection-dropdown";
  paintSelector['pre-selected-colour-collection'] = "data-pre-selected-colour-collection";
  selectors['axis-paint-selector'] = paintSelector;
  // Redirect
  let redirect = {};
  //  Redirect url.
  redirect['url'] = "data-redirect";
  selectors['redirect'] = redirect;
  // Mobile Menus.
  let mobileMenus = {};
  // Initialise - mobile container.
  mobileMenus['initialise'] = "data-mobile-menus";
  // Container - stores all children menus.
  mobileMenus['container'] = "data-mobile-menus-container";
  // Child menu - child menu's that sit inside of the container this must have the same value as the initialise elment.
  mobileMenus['child-menu'] = "data-mobile-menu";
  selectors['mobile-menus'] = mobileMenus;
  // Read more.
  let readMore = {};
  // Initialise.
  readMore['initialise'] = ".read-more";
  // Instance id ( normally this is same as the initialise attribute )
  readMore['instance'] = "rm-id";
  // Should the read more functionality be applicable to only mobile.
  readMore['mobile-only'] = "rm-mobile-only";
  // Read more button close label.
  readMore['closed-text'] = "rm-closed-label";
  // Read more button open label
  readMore['open-text'] = "rm-open-label";
  // Read more button title.
  readMore['title-text'] = "data-title-text";
  // Closed height.
  readMore['closed-height'] = "rm-closed-height";
  // Whether you can reveal the content.
  readMore['reveal'] = "rm-reveal";
  // Content fade
  readMore['content-fade'] = "rm-content-fade";
  // Content truncate - Uses CSS -webkit-line-clamp to add ellipsis after x lines.
  readMore['content-truncate'] = "data-content-truncate";
  // Read more external trigger.
  readMore['trigger'] = "rm-trigger-id";
  // Anchor, scrolls the user to content.
  readMore['anchor'] = "data-anchor-point";
  // Anchor offset.
  readMore['anchor-offset'] = "data-anchor-point-offset";
  // Is the read more content in the tab notes.
  readMore['tabbed-notes'] = "rm-tabbed-notes-content";
  // Reveal button.
  readMore['reveal-button'] = "data-reveal-button";
  // Container offset - offset the height of the container to allow for space top + bottom, this is useful for vertical alignment.
  readMore['container-offset'] = "data-container-offset";
  selectors['axis-read-more'] = readMore;
  // --- Barcode scanner ---
  let barcodeScanner = {};
  // Initialise.
  barcodeScanner['initialise'] = "data-barcode-scanner";
  // Haptic feedback.
  barcodeScanner['haptic-feedback'] = "data-barcode-scanner-haptic-feedback";
  // Trigger button
  barcodeScanner['trigger-button'] = "data-barcode-scanner-trigger";
  // Content Container.
  barcodeScanner['container'] = "data-barcode-scanner-container";
  // Viewfinder overlay ( the area that is being decoded )
  barcodeScanner['viewfinder-overlay'] = "data-scanner-viewfinder-overlay";
  // Viewfinder ( the camera feed from the user's device )
  barcodeScanner['viewfinder'] =  "data-scanner-viewfinder";
  // If available this is where the scanner reference can be outputted for the user to see.
  barcodeScanner['reference-output'] = "data-barcode-reference-output";
  // Used to link DOM element to scanner instance.
  barcodeScanner['scanner-id'] = "data-barcode-scanner-id";
  // Barcode response container 
  barcodeScanner['response-container'] = "data-barcode-response-container";

  barcodeScanner['camera-selector'] = "data-barcode-scanner-camera-selector";
  // camera selector label text - the text that used in the label for the select dropdown.
  barcodeScanner['camera-selector-label-text'] = "data-camera-selector-label-text";
  // camera selector tooltip text - the text that gets down in the tooltip next to the select input.
  barcodeScanner['camera-selector-tooltip-text'] = 
  "data-camera-selector-tooltip-text";
  // scanner-min-quality - the minimum quality of the scan to be concidered valid. "  a symbol confidence metric, an unscaled, relative quantity: larger values are better than smaller values, where "large" and "small" are application dependent. "
  barcodeScanner['scanner-min-quality'] = "data-barcode-scanner-min-quality";
  // User friendly error heading.
  barcodeScanner['user-error-heading'] = "data-user-error-heading";
  // User friendly error prefix text.
  barcodeScanner['user-error-prefix-text'] = "data-user-error-prefix-text";
  // Update input - updates an input value after decoding has successfully completed instead of calling back to the server, this accepts either an input id or name.
  barcodeScanner['update-input'] = "data-update-input";
  // Submit form on decode - to be used with update-input, once deocding is successfully complete submit the containing form for update-input.
  barcodeScanner['submit-on-decode'] = "data-submit-form-on-decode";
  selectors['axis-barcode-scanner'] = barcodeScanner;
  // --- Toggler --- 
  let axisToggler = {}
  // Initialise.
  axisToggler['initialise'] = "data-toggler";
  // Toggle when mouse leaves content.
  axisToggler['content-leave'] = "data-toggle-on-content-leave";
  // Toggler background.
  axisToggler['background'] = "data-toggler-background";
  selectors['axis-toggler'] = axisToggler;
  // --- Button Total Display --- 
  let buttonTotalDisplay = {};
  // Initialise
  buttonTotalDisplay['initialise'] = "data-value-total";
  // Value - The value that get used in the total.
  buttonTotalDisplay['value'] = "data-value";
  selectors['axis-value-total'] = buttonTotalDisplay;
  // --- Redirect ---
  // redirects the user to a specifc location.
  let destination = {};
  // Initialise
  destination['initialise'] = "data-update-location";
  selectors['axis-location'] = destination;
  // --- Responsive Accordion Tabs --- 
  let responsiveTabs = {};
  // Initialise.
  responsiveTabs['initialise'] = "data-responsive-accordion-tabs";
  // Instance container.
  responsiveTabs['container'] = "data-responsive-accordion-tabs-container";
  // Title container.
  responsiveTabs['title-container'] = "data-responsive-tabs-title-container";
  // Trigger button - a nested button inside of the title container that triggers the pane.
  responsiveTabs['trigger-button'] = "data-responsive-tabs-trigger-button";
  // Title link - prevent bubble and opening the accordion / tab pane.
  responsiveTabs['title-link'] = "data-responsive-tabs-title-link";
  // Accordion Toggle all - toggle all button.
  responsiveTabs['accordion-toggle-all'] = "data-accordion-toggle-all";
  // Accordion Toggle all condense text.
  responsiveTabs['toggle-all-contense-text'] = "data-accordion-condense-text";
  // Accordion Toggle all expand text.
  responsiveTabs['toggle-all-expand-text'] = "data-accordion-expand-text";
  // Content - Tab / Pane context, this cannot be changed due to foundation is using this attribute.
  responsiveTabs['content'] = "data-tab-content";
  // Reload - if content was ajax'd in then perform original action again ( e.g. cancel buttons ).
  responsiveTabs['refresh'] = "data-tab-refresh";
  selectors['axis-responsive-tabs'] = responsiveTabs;
  // --- Motion UI ---
  let motionUI = {};
  // Initialise.
  motionUI['initialise'] = "data-motion-ui";
  // Intro Animation type.
  motionUI['intro-animation'] = "data-motion-ui-intro";
  // Outro Animatino type.
  motionUI['outro-animation'] = "data-motion-ui-outro";
  // Animation speed.
  motionUI['animation-speed'] = "data-motion-ui-speed";
  // Loop animation infinitely.
  motionUI['infinite'] = "data-motion-ui-infinite-loop";
  selectors['axis-motion-ui'] = motionUI;

  // --- Element Print --- 
  let elementPrint = {};
  // Initialise.
  elementPrint['initialise'] = "data-element-print";
  // The element id we wish to print.
  elementPrint['container-id'] = "data-element-id";
  // Element print container
  elementPrint['container'] = "data-element-print-container";
  selectors['axis-element-print'] = elementPrint;
  // --- Content Loader Spinners --- 
  let contentLoaderSpinners = {};
  // Initialise.
  contentLoaderSpinners['initialise'] = "data-initialise-content-block";
  // The text that get outputted in the ui blocked area.
  contentLoaderSpinners['text'] = "data-content-loader-text";
  selectors['axis-content-loader-spinners'] = contentLoaderSpinners;
  // --- Code Block --- 
  let codeBlock = {};
  // Initialise.
  codeBlock['initialise'] = "data-code-block";
  // Copy button.
  codeBlock['copy-button'] = "data-code-copy-button";
  // Copy ignore, markup we want to ignore from the copy funciton.
  codeBlock['copy-ignore'] = "data-code-copy-ignore";
  // Sometime the text content within the code block gets modified ( i.e. html escaping or for easier formatting for the end user ).
  codeBlock['raw'] = "data-raw";
  selectors['axis-code-block'] = codeBlock;
  // --- Copy To Clipboard ---
  let copyToClipboard = {};
  // Initialise.
  copyToClipboard['initialise'] = "data-copy-to-clipboard";
  // Copied text.
  copyToClipboard['copied-text'] = "data-copied-text";
  selectors['axis-copy-to-clipboard'] = copyToClipboard;
  // --- Context Menu --- 
  let contextMenu = {};
  // Initialise.
  contextMenu['initialise'] = "data-axis-context-menu";
  // Trigger button.
  contextMenu['trigger'] = "data-axis-context-menu-toggle"
  // Hold the actual menu.
  contextMenu['menu-container'] = "data-axis-context-menu-container";
  selectors['axis-context-menu'] = contextMenu;
  // --- Rich Text Editor ---
  let axisRichTextEditor = {};
  // Initialise.
  axisRichTextEditor['initialise'] = "data-axis-rich-text-editor";
  // Type - are we using CKEditor? 
  axisRichTextEditor['type'] = "data-text-editor-type";
  // Input - input that is binded to editor instance for form submission.
  axisRichTextEditor['input-name'] = "data-text-editor-input-name";
  // Config - to override default.
  axisRichTextEditor['config'] = "data-text-editor-config";
  selectors['axis-rich-text-editor'] = axisRichTextEditor;
  // --- Charts ---
  let axisCharts = {};
  // Initialise.
  axisCharts['initialise'] = "data-axis-charts";
  // Type - the library that is powering this functionality.
  axisCharts['type'] = "data-charts-type";
  // Layout - what kind of chart is this?
  axisCharts['layout'] = "data-charts-layout";
  //  Data - the data the is behind the chart.
  axisCharts['data'] = "data-charts-data";
  // Orientation - vertical or horizontal.
  axisCharts['orientation'] = "data-charts-orientation";
  selectors['axis-charts'] = axisCharts;
  // --- Third-Party Search ---
  let axisThirdPartySearch = {};
  // Initialise.
  axisThirdPartySearch['initialise'] = "data-third-party-search";
  // Type
  axisThirdPartySearch['type'] = "data-search-type";
  // Site Id 
  axisThirdPartySearch['api-key'] = "data-search-api-key";
  // Query.
  axisThirdPartySearch['query'] = "data-search-query";
  // Show Images
  axisThirdPartySearch['show-images'] = "data-search-show-images";
  // Results limit.
  axisThirdPartySearch['results-limit'] = "data-search-results-limit";
  selectors['axis-third-party-search'] = axisThirdPartySearch;
  // --- Schema data ---
  let axisSchemaData = {};
  // Initialise.
  axisSchemaData['initialise'] = "data-structured-data";
  selectors['axis-schema-data'] = axisSchemaData;
  // --- Video Player ---
  let axisVideoPlayer = {};
  // Initialise.
  axisVideoPlayer['initialise'] = "data-video-player";
  // Video URL.
  axisVideoPlayer['url'] = "data-video-player-url";
  // Video duration, used for outputting video duration.
  axisVideoPlayer['duration'] = "data-video-duration";
  selectors['axis-video-player'] = axisVideoPlayer;
  // --- Anchors ---
  let axisAnchors = {};
  // Initialise Id.
  axisAnchors['initialise'] = "data-axis-anchors";
  // Open external links in a new tab.
  axisAnchors['external-links-new-tab'] = "data-open-external-link-new-tab";
  // Should we show external link icon.
  axisAnchors['show-external-icon'] = "data-show-external-link-icon";
  selectors['axis-anchors'] = axisAnchors;
  // --- Opayo Drop-in ---
  let axisOpayoDropIn = {};
  // Initialise.
  axisOpayoDropIn['instance-id'] = "data-axis-opayo-drop-in";
  // Configuration.
  axisOpayoDropIn['config'] = "data-axis-config";
  selectors['axis-opayo-drop-in'] = axisOpayoDropIn;
  // --- Google Pay ---
  let axisGooglePay = {};
  // Instance Id.
  axisGooglePay['instance-id'] = "data-axis-google-pay";
  // Config.
  axisGooglePay['config'] = "data-axis-config";
  selectors['axis-google-pay'] = axisGooglePay;
  // --- Payment Methods ---
  let axisPaymentMethods = {};
  // Initialise.
  axisPaymentMethods['initialise'] = "data-axis-payment-method";
  // Config.
  axisPaymentMethods['config'] = "data-axis-config";
  // Card identifier - used for opayo checkout card identifier when creating a transaction.
  axisPaymentMethods['card-identifier'] = "data-card-identifier";
  // Reusable card identifier - this is used for reusable card identifiers ( i.e. tokens ).
  axisPaymentMethods['reusable-card-identifier'] = "data-reusable-identifier";
  // Merge attributes with payment utility attribures.
  axisPaymentMethods = Object.assign(axisPaymentMethods, paymentSelectorAttibutes);
  selectors['axis-payment-methods'] = axisPaymentMethods;
  // --- Notifications ---
  let axisNotifications = {};
  // Initialise.
  axisNotifications['initialise'] = "data-notification";
  // Work out notification type.
  axisNotifications['type'] = "data-notification-type";
  // Accept button.
  axisNotifications['accept-button'] = "data-accept-button";
  // Cancel button.
  axisNotifications['cancel-button'] = "data-cancel-button";
  selectors['axis-notifications'] = axisNotifications;
  // --- PWA ( Progressive Web Application ) ---
  let pwa = {};
  // Initialise
  pwa['initialise'] = "data-init-pwa";
  // Instance.
  pwa['instance-id'] = "data-pwa-id";
  selectors['axis-pwa'] = pwa;
  // --- Analytics ---
  let analytics = {};
  // Send event.
  analytics['send-event'] = "data-analytics-send-event";
  // Send event on form submit.
  analytics['send-on-submit'] = "data-analytics-send-on-submit";
  selectors['analytics'] = analytics;
  // --- Manage Google Tag Manager Export ---
  let gtm = {};
  // Initialise.
  gtm['initialise'] = "data-manage-google-tag-manager";
  // Container export.
  gtm['container-export'] = "data-container-export";
  // Config.
  gtm['config'] = "data-axis-config";
  // Copy exported config to clipboard.
  gtm['export-to-clipboard'] = "data-export-to-clipboard";
  // Export to file button.
  gtm['export-to-file'] = "data-export-to-file";

  selectors['axis-manage-google-tag-manager'] = gtm;
  // Multi Media Element.
  let multiMediaElement = {};
  // Initialisation.
  multiMediaElement['initialise'] = "data-multimedia-element";
  // Fallback element.
  multiMediaElement['fallback'] = "data-fallback";
  // Fallback text.
  multiMediaElement['fallback-text'] = "data-fallback-text-container";
  // Text error container.
  multiMediaElement['fallback-error-text'] = "data-fallback-error-text";
  // Autoplay.
  multiMediaElement['autoplay'] = "data-autoplay";
  // Loop.
  multiMediaElement['loop'] = "data-loop";
  selectors['axis-multimedia-element'] = multiMediaElement;
  // --- Scroll Into View ---
  // Initialise.
  let scroll = {};
  scroll['initialise'] = "data-scroll-into-view";
  selectors['axis-scroll-into-view'] = scroll;
  // --- File Downloader ---
  let downloadFile = {};
  downloadFile['initialise'] = "data-download-file";
  selectors['axis-download-file'] = downloadFile;
  return selectors;
}

// TODO: DOM mutation observer ( watch an element for changes ).
// window.mutation = (context) => {
  //https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver
// }

//----- Dependancies -----
//--- Console Debugger ---
import { AXISDebug } from './axis-debug';
//Make Module Public the debug module.
window.AXISDebug = AXISDebug;

// --- Basket --- 
import { AXISBasket } from '../components/axis-basket';
// Make Module Public.
window.AXISBasket = AXISBasket;

// --- Content refresh --- 
import { contentRefresh } from '../components/axis-content-refresh';
// Make Module Public.
window.contentRefresh = contentRefresh;

//--- AXIS Responsive Menu ---
import { AXISResponsiveMenu } from '../components/axis-responsive-menu';
// Make Module Public.
window.AXISResponsiveMenu = AXISResponsiveMenu;

// --- Inputs / Validation ---
import { AXISInputs } from './axis-inputs';
// Make Module Public.
window.AXISInputs = AXISInputs;


//TODO: temp initialation ( this needs to be merged into AXISAjax ).
import { AXISLookups } from '../components/axis-lookups';
// Make Module Public.
window.AXISLookups = AXISLookups;

// // Google Recaptcha Functionality.
// import { captcha } from '../components/axis-captcha';
// //Make Module Public AJAX functionality.
// window.captcha = captcha;

//AJAX Functionality.
import { AXISAjax } from './axis-ajax';
// Make Module Public.
window.AXISAjax = AXISAjax;

// Update url.
import { updateUrl } from '../components/axis-update-url';
// Make Module Public.
window.updateUrl = updateUrl;

//--- AXIS Quantity Selectors ---
import { AXISQuantitySelectors } from '../components/axis-quantity-selectors';
// Make Module Public.
window.AXISQuantitySelectors = AXISQuantitySelectors;

// AXIS Sliders
import { AXISSliders } from '../components/axis-sliders';
// Make Module Public.
window.AXISSliders = AXISSliders;

// --- PWA  --- 
import { AXISPWA } from '../components/axis-pwa';
// Make Module Public.
window.AXISPWA = AXISPWA;

//--- Notification ---
import { notifications } from '../components/axis-notifications';
notifications.initialiseAll();
// Make Module Public.
window.notifications = notifications;

// --- AXIS Callouts --- 
import { callouts } from '../components/axis-callouts';
// Make Module Public.
window.callouts = callouts;

//--- Tooltip --- 
import { AXISTooltip } from '../components/axis-tooltip';
//Make Module Public module.
window.AXISTooltip = AXISTooltip;

// ----- Number animation -----
import { AXISCounter } from '../components/axis-counter';
// Make Module Public.
window.AXISCounter = AXISCounter;

// ----- AXIS Modules functionality ----- 
import { AXISModules } from '../components/axis-modules';
// Make Module Public.
window.AXISModules = AXISModules;

// ----- AXIS Account functionality ----- 
import { AXISAccount } from '../components/axis-account';
// Make Module Public.
window.AXISAccount = AXISAccount;

// ----- AXIS Modals functionality ----- 
import { AXISModals }  from '../components/axis-modals';
// Make Module Public modules.
window.AXISModals = AXISModals;

// ----- AXIS Typography ----- 
import { AXISTypography } from '../components/axis-typography';
// Make Module Public modules.
window.AXISTypography = AXISTypography;

//--- AXIS Read more --- 
import { AXISReadMore } from '../components/axis-read-more';
//Make Module Public module.
window.AXISReadMore = AXISReadMore;

//--- AXIS Message event interface --- 
import { messageEvents } from '../components/axis-message-event';
// Make Module Public.
window.messageEvents = messageEvents;

// --- Stockline --- 
// import { stockline } from '../components/axis-stockline';
// // Make Module Public.
// window.stockline = stockline;

// --- Stock Indiciator --- 
import { stockIndicators } from '../components/axis-stock-indicator';
// Make Module Public.
window.stockIndicators = stockIndicators;

// --- Favourites ---
import { favourites } from '../components/axis-favourites';
// Make Module Public.
window.favourites = favourites;

// --- Responsive Tabs --- 
// import { AXISReponsiveTabs } from '../components/axis-responsive-tabs';
// // Make Module Public.
// window.AXISReponsiveTabs = AXISReponsiveTabs;

// --- Countdown --- 
// import { AXISCountdown } from '../components/axis-countdown';
// // Make Module Public.
// window.AXISCountdown = AXISCountdown;

// --- Client Search --- 
import { clientSearch } from '../components/axis-client-end-search';
// Make Module Public.
window.clientSearch = clientSearch;

// // --- Animations --- 
// import { animations } from '../components/axis-animations';
// // Make Module Public.
// window.animations = animations;

// --- Animations --- 
import { AXISSticky } from '../components/axis-sticky';
// Make Module Public.
window.AXISSticky = AXISSticky;

// --- Service Worker  --- 
import { AXISServiceWorker } from '../components/axis-service-worker';
// Make Module Public.
window.AXISServiceWorker = AXISServiceWorker;

// --- Style Guide --- 
import { styleguide } from '../components/axis-style-guide';
// Make Module Public.
window.styleguide = styleguide;

// --- Table Of Contents --- 
import { AXISTableOfContents } from '../components/axis-table-of-contents';
// Make Module Public.
window.AXISTableOfContents = AXISTableOfContents;

// --- Back to top --- 
import { backToTop } from '../components/axis-back-to-top';
// Make Module Public.
window.backToTop = backToTop;

// --- Axis Sections ---
import { sections } from '../components/axis-sections';
// Make Module Public.
window.sections = sections;

// --- Axis Ellipsis --- 
import { ellipsis } from '../components/axis-ellipsis';
// Make Module Public
window.ellipsis = ellipsis;

// --- vmAdmin v2 ---
// import { vmadmin } from '../components/axis-admin';
// // Make Module Public.
// window.vmadmin = vmadmin;

// --- Equaliser --- 
import { equaliser } from '../components/axis-equaliser';
// Make Module Public.
window.equaliser = equaliser;

// --- Carousels --- 
// import { carousels } from '../components/axis-carousels';
// // Make Module Public.
// window.carousels = carousels;

// --- Text equaliser --- 
// DEPRICATED: Using axis-table-column-equaliser instead.
// import { tableTextEqualiser } from '../components/axis-text-equaliser';
// // Make Module Public.
// window.tableTextEqualiser = tableTextEqualiser;
import { AXISTableColumnEqualiser } from '../components/axis-table-column-equaliser';
// Make Module Public.
window.AXISTableColumnEqualiser = AXISTableColumnEqualiser;

// --- Axis Toggler --- 
import { AXISToggler } from '../components/axis-toggler';
// Make Module Public.
window.AXISToggler = AXISToggler;

// --- Axis Mega Menu --- 
import { AXISMegaMenu } from '../components/axis-mega-menu';
// Make Module Public.
window.AXISMegaMenu = AXISMegaMenu;

// --- Axis Geolocation ---
import { AXISGeoLocation } from '../components/axis-geo-location';
// Make Module Public.
window.AXISGeoLocation = AXISGeoLocation;

// --- Axis Interactive Maps --- 
// import { AXISInteractiveMaps } from '../components/axis-interactive-maps';
// // Make Module Public.
// window.AXISInteractiveMaps = AXISInteractiveMaps;

// --- Axis Tree Menu --- 
// import { treeMenu } from '../components/axis-tree-menu';
// // Make Module Public.
// window.treeMenu = treeMenu;

// --- AXIS Redirect --- 
import { AXISRedirect } from '../components/axis-redirect';
// Make Module Public.
window.AXISRedirect = AXISRedirect;

// --- AXIS Barcode Scanner --- 
// import { axisBarcodeScanner } from '../components/axis-barcode-scanner';
// // Make Module Public.
// window.axisBarcodeScanner = axisBarcodeScanner;

// --- AXIS Barcode Scanner --- 
import { AXISMobileMenus } from '../components/axis-mobile-menus';
// Make Module Public.
window.AXISMobileMenus = AXISMobileMenus;

// --- AXIS Component Loader ---
import { component as components } from '../components/axis-component-loader';
// Make Module Public.
window.components = components;

